import styled, { css } from 'styled-components'

export const BodyCell = styled.td`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  white-space: nowrap;
  cursor: pointer;

  ${props =>
    props.isCancelled &&
    css`
      text-decoration: line-through;
      color: ${props => props.theme.colors.text.subtle};
    `}
`

export const ParcelRow = styled.tr`
  ${props =>
    props.isParcelDetailSelected &&
    css`
      border: 3px solid ${props => props.theme.colors.info.default};
    `}

  ${props =>
    props.error &&
    css`
      background-color: ${props => props.theme.colors.warning.surface}!important;
    `}

  ${props =>
    props.selected &&
    css`
      background-color: ${props => props.theme.colors.success.surface}!important;
    `}
`

export const NameCell = styled(BodyCell)`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const RowLink = styled.a`
  display: contents;
  color: inherit;
  text-decoration: none;
`
